import { useCallback, useMemo } from "react";
import { Chip } from "@mui/material";

import useQuoteData from "components/Quotes/useQuoteData";
import { useTranslations } from "@fenetech/translations";
import { RoleEnum, ThemeColorEnum } from "helpers/enums";
import useUserInfo from "helpers/context/User/useUserInfo";

function SubmittedChip() {

    const { quote } = useQuoteData();
    const tm = useTranslations();
    const user = useUserInfo();

    const isContractor = useMemo(() => {
        return user.HasRole(RoleEnum.Contractor);
    }, [user]);

    const getLabel = useCallback(() : any => {
        if (quote && quote.isContractorCreatedQuote && quote.isSubmitted)
        {
            if (quote.contractorOrderNumber) {
                return isContractor ? "" : tm.Get("Customer Quote")
            }
            return tm.Get("Submitted");
        }
        return "";

    }, [quote, tm, isContractor]);

    return <>
        {(quote && getLabel()) && 
            <Chip color={ThemeColorEnum.Primary} label={getLabel()} />
        }
    </>;

}

export default SubmittedChip;